import { At } from '@phosphor-icons/react';

export default At;